import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import CompositiontemplateFilterCriteria from './CompositiontemplateFilterCriteria'
import CompositiontemplateList from './CompositiontemplateList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './CompositiontemplateAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setCompositiontemplateDashboardCompositiontemplateList } from '../../store/slice/PharmaSlice';

export default function CompositiontemplateListView({setShowEdit,setCompositiontemplateId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.compositiontemplateDashboard);   

    const [filteredCompositiontemplateList, setFilteredCompositiontemplateList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { compositiontemplateDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (compositiontemplateDashboard.compositiontemplateList.length>-1){
        setFilteredCompositiontemplateList(compositiontemplateDashboard.compositiontemplateList);
        transformToCardFormat(compositiontemplateDashboard.compositiontemplateList, setCardList);
      }
    },[compositiontemplateDashboard.compositiontemplateList])

    useEffect(()=>{
          transformToCardFormat(filteredCompositiontemplateList, setCardList);
      },[filteredCompositiontemplateList])

    useEffect(()=>{
        if (filterCriteria.title==='' ){
            setFilteredCompositiontemplateList(compositiontemplateDashboard.compositiontemplateList);
            transformToCardFormat(compositiontemplateDashboard.compositiontemplateList, setCardList);

        } else {
            setFilteredCompositiontemplateList(
                compositiontemplateDashboard.compositiontemplateList
                    .filter(compositiontemplate=> compositiontemplate.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(compositiontemplateDashboard.filteredCompositiontemplateList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <CompositiontemplateList
                    setShowEdit={setShowEdit}
                    setCompositiontemplateId = {setCompositiontemplateId}
                    tableList={filteredCompositiontemplateList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}